<div
  (mouseenter)="collapseOpenSidenav()"
  (mouseleave)="collapseCloseSidenav()"
  [class.collapsed]="collapsed"
  [class.open]="collapsed && (collapsedOpen$ | async)"
  class="sidenav flex flex-col"
>
  <div class="ratenow-sidenav-toolbar__container">
    <div class="sidenav-toolbar flex-none flex items-center">
      @if (aplicationType === aplicationTypeName.closeTheLoop) {
        <img class="w-full mx-auto object-scale-down" src="assets/img/logos/logo-ctl.svg" />
      } @else {
        <img [src]="imageUrl$ | async" alt="Logo" class="w-20 select-none flex-none" />
      }

      @if (showCollapsePin$ | async) {
        <button (click)="toggleCollapse()" class="ratenow-sidenav-toolbar__icon leading-none flex-none hidden lg:block" mat-icon-button type="button">
          @if (!collapsed) {
            <mat-icon class="contrast-icon" svgIcon="mat:radio_button_checked"></mat-icon>
          }
          @if (collapsed) {
            <mat-icon class="contrast-icon" svgIcon="mat:radio_button_unchecked"></mat-icon>
          }
        </button>
      }
    </div>

    @if (searchVisible$ | async) {
      <div class="ratenow-sidenav-search__container">
        <div class="ratenow-sidenav-search relative" matRipple matRippleColor="var(--sidenav-item-ripple-color)">
          <mat-icon class="flex-none ratenow-sidenav-search__icon" svgIcon="mat:search"></mat-icon>
          <div class="flex-auto ratenow-sidenav-search__placeholder">
            {{ 'sidenav-menu.quick-search' | translate }}
          </div>
          <div class="flex-none ratenow-sidenav-search__keybind">Ctrl K</div>
        </div>
      </div>
    }

    <div class="ratenow-sidenav-toolbar__divider"></div>
  </div>

  <nx-ratenow-ui-scrollbar class="flex-1 flex flex-col">
    <div class="pt-6 flex-1">
      @for (item of items; track trackByRoute($index, item)) {
        <nx-ratenow-ui-sidenav-item [item]="item" [level]="0"></nx-ratenow-ui-sidenav-item>
      }
    </div>
  </nx-ratenow-ui-scrollbar>
</div>
